import * as React from "react";
import { connect } from "react-redux";
import { selectCategoryPosition } from "../../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../../constants/IdMenuBalancing";
import { selectActiveCollectEventEventInfo } from "../../../selectors/selectCollectEvents";
import { selectIsCollectLeagueAvailable, selectIsRankingAvailable, selectIsTournamentLevelMatched, selectTournamentEndTime, } from "../../../selectors/selectTournamentInfo";
import { actionPlayerLeagueDeselectLeague } from "../../info/league/actionPlayerLeagueInfo";
import { MenuWrapper } from "../../menus/MenuWrapper";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TimeRemaining } from "../../time/TimeRemaining";
import { IdCollectCategory } from "../IdCollectCategory";
export var _MenuTournament = function (_a) {
    var onClose = _a.onClose, endTime = _a.endTime, selectedTab = _a.selectedTab, isRankingTabAvailable = _a.isRankingTabAvailable, isRewardsTabAvailable = _a.isRewardsTabAvailable;
    if (endTime == undefined || selectedTab == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var timeRemaining = endTime > 0 ? React.createElement(TimeRemaining, { remainingTime: endTime }) : undefined;
    var passGetLockedTabs = function (tabs) {
        return getLockedTabs(tabs, isRankingTabAvailable, isRewardsTabAvailable);
    };
    return (React.createElement(MenuWrapper, { onClose: onClose, className: "tournament-dialog", type: IdMenuBalancing.CollectMenu, lockedTabs: passGetLockedTabs, footerRenderer: timeRemaining, activeTabIndex: selectedTab, modalId: IdModal.CollectEvent }));
};
var getLockedTabs = function (tabs, isRankingTabAvailable, isRewardsTabAvailable) {
    var returnedTabs = [];
    if (!isRankingTabAvailable) {
        returnedTabs.push(IdCollectCategory.LeagueRanking);
    }
    if (!isRewardsTabAvailable) {
        returnedTabs.push(IdCollectCategory.LeagueOverview);
    }
    return returnedTabs;
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.CollectEvent));
        dispatch(actionPlayerLeagueDeselectLeague());
    },
}); };
var mapState = function (state) {
    var currentTournamentData = selectActiveCollectEventEventInfo(state);
    var isEventRunning = selectIsCollectLeagueAvailable(state);
    if (!isEventRunning ||
        currentTournamentData == undefined ||
        currentTournamentData.balancing == undefined) {
        return {
            isRankingTabAvailable: false,
            isRewardsTabAvailable: false,
        };
    }
    var isRankingAvailable = selectIsRankingAvailable(state);
    var selectedTab = isRankingAvailable
        ? selectCategoryPosition(IdMenuBalancing.CollectMenu, IdCollectCategory.LeagueRanking)
        : 0;
    return {
        endTime: selectTournamentEndTime(state, currentTournamentData),
        isRankingTabAvailable: selectIsRankingAvailable(state),
        isRewardsTabAvailable: selectIsTournamentLevelMatched(state, currentTournamentData.balancing.type),
        selectedTab: selectedTab,
    };
};
export var MenuCollectEvent = connect(mapState, mapDispatch)(_MenuTournament);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/collect-event/MenuCollectEvent.tsx
// module id = 2940
// module chunks = 3